<!--//模板 html结果-->
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<!--行为 处理逻辑-->
<script>
  import jwt_decode from 'jwt-decode'
  export default {
    methods: {

      isEmpty(value){
        return(
          value === undefined ||
          value === null ||
          (typeof value === 'object' && Object.keys(value).length === 0) ||
          (typeof value === 'string' && value.trim().length === 0)
        )
      }
    },
    created() {
      if (localStorage.eleToken){
        const decoded = jwt_decode(localStorage.eleToken);
        this.$store.dispatch("setAuthenticated",!this.isEmpty(decoded));
        this.$store.dispatch("setUser",decoded);
      }
    }
  }
</script>


<!--样式-->
<style>
  * {
    margin: 0;
    padding: 0;
    text-decoration: none;
    list-style: none;
    font-family: '微软雅黑';
    font-size: 16px;
  }

  html, body {
    width: 100%;
    height: 100%;
  }

  #app {
    width: 100%;
    height: 100%;
  }
  #app>div{
    width: 100%;
    height: 100%;
  }
  #container {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .el-input__inner{padding-left:10px!important}
</style>



// WEBPACK FOOTER //
// src/App.vue